/**
 * Generate a URL for an asset
 * @param {string} path - The path to the asset relative to the public directory
 * @returns {string} The complete URL to the asset
 */
export function asset(path) {
    // Remove leading slash if present
    path = path.replace(/^\//, '');

    // Check if we're in a browser environment
    if (typeof document !== 'undefined') {
        // Get the base URL from the meta tag (if you're using one)
        const baseUrl = document.querySelector('meta[name="base-url"]')?.getAttribute('content') || '';
        return `${baseUrl}/${path}`;
    } else {
        // Server-side rendering environment
        return `/${path}`;
    }
}

export default asset;
